
import React from 'react';
import {FormGroup, Input, Label} from 'reactstrap';

function field({
	name,
	label,
	type = 'text',
	size = '12',
	options = null,
	value,
	setValue,
	errors,
	required = false,
	trigger,
	readOnly = false,
	isShown = true,
	fromNewLine = false,
	disabled = false,
	savedCardValue = null,
	helperText = '',
}) {
	return <>
		{fromNewLine && <div className={`col-${size}`}/>}
		<FormGroup key={name} className={`${isShown ? '' : 'd-none'} col-${size} fields-wrapper field-${name}-wrapper gamapay-control gamapay-control-${name}`}>
			<Label for={name}>
				{label} {required && <span className='text-danger'>*</span>}
			</Label>
			<Input
				dir={savedCardValue ? 'ltr' : 'rtl'}
				name={name}
				id={name}
				type={type}
				value={savedCardValue ?? value}
				invalid={Boolean(errors[name])}
				options={options}
				autoComplete='off'
				readOnly={readOnly}
				className={`input-field input-web ${savedCardValue && 'saved-card-value'} gamapay-field-${type}`}
				disabled={disabled}
				onChange={({target: {value, checked}}) => {
					setValue(name, (type === 'checkbox') ? checked : value);
					setTimeout(() => trigger(name), 50);
				}}
			>
				{options ? options.map(key => (
					<option key={key} value={key}>{'\u200F' + key}</option>
				)) : null}
			</Input>
			{helperText && <div className='text-muted small mt-1'>{helperText}</div>}
			{(errors[name] && errors[name].message) && <div className='text-danger small mt-1'>{errors[name].message}</div>}
		</FormGroup>
	</>;
}

export default field;
